module.exports = __webpack_public_path__ + "static/media/rang.fce91ddc.gif";